import { Route, Routes } from '@angular/router';
import { psFirebaseAuthGuard, psFirebaseGuestRedirectToLoginGuard } from './guards/ps-firebase-auth.guard';

/** Shared `/ps` feature — used by main app and by the personal-secretary standalone build */
export const personalSecretaryRoute: Route = {
  path: 'ps',
  loadComponent: () =>
    import('./ps-layout/ps-layout.component').then((m) => m.PsLayoutComponent),
  children: [
    {
      path: '',
      loadComponent: () =>
        import('./ps-home/ps-home.component').then((m) => m.PsHomeComponent),
      canActivate: [psFirebaseGuestRedirectToLoginGuard],
    },
    {
      path: 'reminder/create',
      loadComponent: () =>
        import('./reminder/reminder.component').then((m) => m.ReminderComponent),
      canActivate: [psFirebaseAuthGuard],
    },
    {
      path: 'login',
      loadComponent: () =>
        import('./ps-login/ps-login.component').then((m) => m.PsLoginComponent),
    },
    {
      path: 'routine',
      loadComponent: () =>
        import('./ps-routine/ps-routine.component').then((m) => m.PsRoutineComponent),
      canActivate: [psFirebaseAuthGuard],
    },
    {
      path: 'alerts',
      loadComponent: () =>
        import('./ps-alerts/ps-alerts.component').then((m) => m.PsAlertsComponent),
      canActivate: [psFirebaseAuthGuard],
    },
    {
      path: 'voice-notes',
      loadComponent: () =>
        import('./ps-voice-notes/ps-voice-notes.component').then((m) => m.PsVoiceNotesComponent),
      canActivate: [psFirebaseAuthGuard],
    },
    {
      path: 'profile',
      loadComponent: () =>
        import('./ps-profile/ps-profile.component').then((m) => m.PsProfileComponent),
      canActivate: [psFirebaseAuthGuard],
    },
    {
      path: 'personal-details',
      loadComponent: () =>
        import('./ps-personal-details/ps-personal-details.component').then(
          (m) => m.PsPersonalDetailsComponent,
        ),
      canActivate: [psFirebaseAuthGuard],
    },
  ],
};

/**
 * Routes for `ng build personal-secretary` — default URL `/` opens Personal Secretary (`/ps`).
 */
export const personalSecretaryStandaloneRoutes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'ps' },
  personalSecretaryRoute,
  { path: '**', redirectTo: 'ps' },
];
